import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useOperatorTailContext } from 'src/contexts/operator-tail.context';
import { IOperatorTail } from 'src/models/operator-tail.model';
import Lang from 'src/libraries/language';
import { getOperatorTailStatus } from 'src/selectors/operator-tail.selector';
import { actionTypes } from 'src/ducks/operator-tail.duck';
import styles from '../operator-tail-number-relationship-list/operator-tail-number-relationship-list.module.scss';

type IProp = {
  data: IOperatorTail;
};

const OperatorTailsDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useOperatorTailContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getOperatorTailStatus(
    state,
    actionTypes.OPERATOR_TAIL_NUMBER_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.otId) {
      const response = await actions.itemDELETE(data.otId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();
        ToastSuccess(Lang.MSG_OPERATOR_TAIL_NUMBER_DELETE_SUCCESS);
      } else {
        ToastError(response.error.message);
      }
    }
  }, [data, actions]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={styles.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_OPERATOR_TAIL_NUMBER}
      content={
        <div className={styles.content}>
          {Lang.MSG_OPERATOR_TAIL_NUMBER_CONFIRM_DELETE}
        </div>
      }
      actions={
        <div className={styles.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorTailsDelete;
